// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._hotkeyList_riohA {
	--form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
}
._hotkeyList__heading_UQr9K {
	font-weight: var(--font-weight-heading, bold);
	margin-inline: var(--form-element-label-offset);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcHotkeyList-D7NVZF42.css"],"names":[],"mappings":";AACA;CACC,8FAA8F;AAC/F;AACA;CACC,6CAA6C;CAC7C,+CAA+C;AAChD","sourcesContent":["\n._hotkeyList_riohA {\n\t--form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n}\n._hotkeyList__heading_UQr9K {\n\tfont-weight: var(--font-weight-heading, bold);\n\tmargin-inline: var(--form-element-label-offset);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
